import React from "react";
import './AboutUs.css';
import LogoDropDown from "../LogoDropDown/logoDropDown";
import CTAButton from "../utils/Button/CTAButton";

function AboutUsShop() {
    return (
        <div className="about-us-container">
            <div className='about-us-header'>
                <LogoDropDown activeItems={[".shop"]}/>
            </div>
            <div className="about-us-main">
                Schmodel.Shop is the exclusive online<br/>
                marketplace where fashion and beauty<br/>
                icons create personal stores.<br/>
                <br/>
                Resell your preloved luxury closet.<br/>
                <br/>
                Affiliate with friends and local brands <br/>
                to sell their products to your fans. <br/>
                <br/>
                Connect with your followers on <br/>
                a different level.<br/>
                <br/>
                Members only.

            </div>
            <div
                className="about-us-footer"
            >
                <div style={{ width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {/* Center apply button in available space between text and footer*/}
                    <CTAButton
                        onClick={() => window.location.href = `${process.env.REACT_APP_CLUB_URL}/memberships`}
                        text={'Apply'}
                    />
                </div>
                <p
                    style={{
                        color: '#B08D57',
                        fontFamily: 'Playfair Display',
                        fontWeight: 800,
                        fontSize: 'clamp(14px, 2.8vh, 20px)',
                        lineHeight: 0.9
                    }}
                >
                    Circular Luxury. Creator Inspired.
                </p>
            </div>
        </div>
    );
}

export default AboutUsShop;
